const OPTIMIZELY_EVENT_DEBUG_QUERY_PARAM = 'debugOptimizelyEvents'

type OptimizelySdkLogLevel = 'DEBUG' | 'ERROR'

export const isOptimizelyDebugLoggingEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  return isOptimizelyDebugLoggingEnabledForQueryValue(
    new URLSearchParams(window.location.search).get(
      OPTIMIZELY_EVENT_DEBUG_QUERY_PARAM,
    ),
  )
}

export const isOptimizelyDebugLoggingEnabledForQueryValue = (
  debugParamValue?: string | string[] | null,
): boolean => {
  const resolvedDebugParamValue = Array.isArray(debugParamValue)
    ? debugParamValue[0]
    : debugParamValue

  return (
    resolvedDebugParamValue !== null &&
    resolvedDebugParamValue !== undefined &&
    resolvedDebugParamValue.toLowerCase() !== 'false'
  )
}

export const getOptimizelySdkLogLevel = (
  debugParamValue?: string | string[] | null,
): OptimizelySdkLogLevel => {
  const isDebugLoggingEnabled =
    debugParamValue === undefined
      ? isOptimizelyDebugLoggingEnabled()
      : isOptimizelyDebugLoggingEnabledForQueryValue(debugParamValue)

  return isDebugLoggingEnabled ? 'DEBUG' : 'ERROR'
}
